export enum ProfileDetailsBoxType {
    PERSONAL_DETAILS = "PERSONAL_DETAILS",
    MORE_DETAILS = "MORE_DETAILS"
}
